import { H2 } from "@sellar-io/components";
import {
  OrderFulfillmentType,
  OrderDeliveryHistoryResponseType,
} from "@sellar-io/api-v2/types";
import { ReactElement } from "react";
import { twMerge } from "tailwind-merge";
import { OrderStage } from "./helpers";

export const OrderStatusHeader = ({
  stage,
  fulfillmentType,
  fulfilment,
}: {
  stage: OrderStage;
  fulfillmentType?: OrderFulfillmentType;
  fulfilment?: OrderDeliveryHistoryResponseType["fulfilment"];
}): ReactElement => {
  switch (stage) {
    case "Requested":
      return <H2 className={twMerge("text-yellow-500")}>Order requested</H2>;
    case "Accepted":
      return <H2 className="text-amber-500">Order accepted</H2>;
    case "Confirmed":
      return <H2 className="text-emerald-500">Order finalised</H2>;
    case "Dispatched":
      return (
        <H2 className="text-violet-500">
          {fulfilment === "partialDispatch"
            ? "Order partially dispatched"
            : "Order dispatched"}
        </H2>
      );
    case "Delivered":
      if (fulfilment === "noDelivery") {
        return <H2 className="text-blue-500">No items delivered</H2>;
      }
      if (fulfilment === "partialDelivery") {
        return <H2 className="text-blue-500">Order partially delivered</H2>;
      }
      return (
        <H2 className="text-blue-500">
          Order {fulfillmentType === "collection" ? "collected" : "delivered"}
        </H2>
      );
    case "Cancelled":
      return <H2 className="text-red-500">Order cancelled</H2>;
    case "Voided":
      return <H2 className="text-zinc-500">Order voided</H2>;
  }
};
